import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("albion_cart") || "[]"));
  const [open, setOpen] = useState(false);

  useEffect(() => localStorage.setItem("albion_cart", JSON.stringify(items)), [items]);

  const add = (p, qty = 1) => {
    const max = Math.min(20, p.stock_qty ?? 20);
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, max, qty: Math.min(max, i.qty + qty) } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price, image_url: p.image_url, store: p.store, max, qty: Math.min(max, qty) }];
    });
    toast.success(`${p.name} added to basket`);
  };
  const addHamper = (tier, picks) => {
    const line = {
      id: `hamper-${Date.now()}`, name: `Gift Hamper (${tier.size} treats)`, price: tier.price,
      image_url: picks[0].image_url, store: "Hamper", max: 5, qty: 1,
      hamper: { product_ids: picks.map((p) => p.id) }, contents: picks.map((p) => p.name),
    };
    setItems((prev) => [...prev, line]);
    toast.success("Hamper added to basket");
    setOpen(true);
  };
  const setQty = (id, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(i.max ?? 20, qty) } : i))));
  const clear = () => setItems([]);
  const replace = (list) => setItems(list);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = Math.round(items.reduce((s, i) => s + i.price * i.qty, 0) * 100) / 100;
    return { items, add, addHamper, setQty, clear, replace, count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
